"use client";

import { useTransition } from "react";
import { useRouter } from "next/navigation";
import { disableDraftMode } from "@/app/actions";

export function DisableDraftMode() {
  const router = useRouter();
  const [pending, startTransition] = useTransition();

  if (typeof window !== 'undefined' && (window !== window.parent || !!window.opener)) {
    return null;
  }

  const disable = () =>
    startTransition(async () => {
      await disableDraftMode();
      router.refresh();
    });

  return (
    <div className="fixed bottom-4 left-4 z-50 group">
      {pending ? (
        <div className="bg-black text-white px-4 py-2 rounded-full text-sm font-medium">
          Disabling draft mode...
        </div>
      ) : (
        <div className="relative">
          <button 
            type="button" 
            onClick={disable}
            className="bg-black text-white px-4 py-2 rounded-full text-sm font-medium hover:bg-gray-800 transition-colors"
          >
            Disable draft mode
          </button>
          
          {/* Popover */}
          <div className="invisible group-hover:visible absolute bottom-full left-0 mb-2 px-3 py-2 bg-black text-white text-sm rounded-lg shadow-lg whitespace-nowrap">
            Draft mode shows changes from Sanity IMMEDIATELY
            <div className="absolute top-full left-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-black"></div>
          </div>
        </div>
      )}
    </div>
  );
}